// extracted by mini-css-extract-plugin
export default {"relative":"burger-ingredients_relative__zvG0H","overflow":"burger-ingredients_overflow__gq06p","modalSize":"burger-ingredients_modalSize__Y9Qoq"};